import React from 'react';
import { Copy } from 'lucide-react';
import toast from 'react-hot-toast';

interface SimpleTransporterIdCardProps {
  name: string;
  transporterId: string;
}

export const SimpleTransporterIdCard: React.FC<
  SimpleTransporterIdCardProps
> = ({ name, transporterId }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(transporterId);
    toast.success('Copied to clipboard!');
  };

  return (
    <div className="flex flex-col gap-1.5 rounded-lg border border-gray-200 bg-gray-50 p-3 hover:bg-gray-100 transition-colors overflow-hidden">
      <div
        className="font-semibold font-base text-gray-900 text-sm truncate"
        title={name}
      >
        {name}
      </div>
      <div className="flex items-center justify-between w-full gap-2">
        <span className="font-mono text-gray-700 tracking-wide text-xs sm:text-sm font-bold bg-white px-2 py-1 rounded border border-gray-200 truncate">
          {transporterId}
        </span>
        <button
          onClick={handleCopy}
          className="p-1.5 text-gray-400 hover:text-teal hover:bg-white rounded border border-transparent hover:border-gray-200 transition-all shrink-0"
          title="Copy Transporter ID"
        >
          <Copy className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
